import { render, staticRenderFns } from "./SessionForceClose.vue?vue&type=template&id=f9a936a8&"
import script from "./SessionForceClose.vue?vue&type=script&lang=js&"
export * from "./SessionForceClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports